<template>
  <div class="reason-cell">
    <z-cell-group>
      <z-cell v-for="(item,index) in cellList" :key="index"
        @click="reasonClick(item)"
        :is-link="true"
      >
        <span slot="title" class="level-one">{{item.type}}</span>
        <span slot="label">{{item.black}}</span>
      </z-cell>
    </z-cell-group>
  </div>
</template>
<script>
import { Cell, CellGroup } from '@zz-common/zz-ui';
export default {
  name: 'reasonCell',
  components: {
    'z-cell': Cell,
    'z-cell-group': CellGroup
  },
  props: {
    cellList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  methods: {
    //原因点击向外触发点击事件
    reasonClick(item) {
      this.$emit('cellClick', item)
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>